import { useState } from "react";
import { adminReturnPath } from "../../../../shared/helpers/adminReturnPath";
import "../styles/HomeScreenApps.css";

const destinations = [
  ["/admin/videos", "Upload Video", "publishing"],
  ["/admin/analytics", "Analytics", "publishing"],
  ["/admin/dashboard", "Publishing Dashboard", "publishing"],
  ["/avwakinentertainment/admin/upload-video", "Entertainment Uploads", "entertainment"],
  ["/avwakinentertainment/admin", "Entertainment Settings", "entertainment"],
  ["/avwakindevelopment/admin", "Development Dashboard", "development"],
];
const icons = { publishing: ["Avwakin Publishing", "/logo192.png"], development: ["Avwakin Development", "/home-screen-development.png"], entertainment: ["Avwakin Entertainment", "/home-screen-entertainment.png"] };
export default function AdminHomeScreenApps() {
  const [destination, setDestination] = useState(destinations[0][0]);
  const [customPath, setCustomPath] = useState("/admin/");
  const [name, setName] = useState("Upload Video");
  const [icon, setIcon] = useState("publishing");
  const [prepared, setPrepared] = useState("");
  const [error, setError] = useState("");
  function selectDestination(value) {
    setDestination(value); setPrepared(""); setError("");
    const preset = destinations.find(item => item[0] === value);
    if (preset) { setName(preset[1]); setIcon(preset[2]); }
  }
  function prepare(event) {
    event.preventDefault();
    const target = adminReturnPath(destination === "custom" ? customPath : destination, "");
    if (!target || !name.trim()) { setError("Choose an admin page and enter an app name."); return; }
    setError("");
    setPrepared(`/home-screen.html?${new URLSearchParams({ to: target, name: name.trim(), icon })}`);
  }
  return <section className="homeScreenSettings">
    <h1>Create Home Screen App</h1>
    <p>Give each app its own starting page, name, and brand icon. You can add Upload Video, Analytics, and other admin pages separately.</p>
    <form onSubmit={prepare} onChange={() => setPrepared("")}>
      <label>Starting page<select value={destination} onChange={event => selectDestination(event.target.value)}>{destinations.map(item => <option key={item[0]} value={item[0]}>{item[1]}</option>)}<option value="custom">Another admin page</option></select></label>
      {destination === "custom" && <label>Admin page path<input value={customPath} onChange={event => setCustomPath(event.target.value)} placeholder="/admin/orders" maxLength={1500} required /><small>Use a path under /admin, /avwakindevelopment/admin, or /avwakinentertainment/admin.</small></label>}
      <label>App name<input value={name} onChange={event => setName(event.target.value)} maxLength={40} required /></label>
      <label>App icon<select value={icon} onChange={event => setIcon(event.target.value)}>{Object.entries(icons).map(([key, item]) => <option key={key} value={key}>{item[0]}</option>)}</select></label>
      <div className="homeScreenPreview"><img src={icons[icon][1]} alt={`${icons[icon][0]} app icon`} /><strong>{name.trim() || "Your app"}</strong></div>
      <button type="submit">Prepare Home Screen App</button>
    </form>
    {error && <p role="alert">{error}</p>}
    {prepared && <div className="homeScreenReady" role="status"><h2>Ready to add {name.trim()}</h2><p>On your iPhone, open the installation page in Safari. Use Share → Add to Home Screen, keep “Open as Web App” on if shown, confirm the name, then tap Add.</p><a className="homeScreenInstallLink" href={prepared}>Open installation page</a><p>Repeat for each app you want. An existing icon keeps its old configuration; remove it and add the replacement when you change its starting page.</p></div>}
    <p>You may need to sign in inside each installed app. Login returns you to its chosen admin page. Uploads require an internet connection; keep the app open while sending a file.</p>
  </section>;
}
